import {useEffect, useState} from 'react'
import * as Yup from 'yup'
import {ErrorMessage, Field, Form, Formik} from 'formik'
import {useDispatch, useSelector} from 'react-redux'
import Swal from 'sweetalert2'
import { Dispatch } from 'redux'
import {useNavigate} from 'react-router-dom'
import {postRequest} from '../../../setup/redux/common/cruds'
import {RootState} from '../../../setup'
import {PageTitle} from '../../../_metronic/layout/core'
import {Loader} from '../../services/Loader'
import PasswordValidationUI, {
  checkPasswordValidity,
} from '../../components/common/PasswordValidationUI'
import {toAbsoluteUrl, KTSVG} from '../../../_metronic/helpers'
import {CustomInput} from '../auth/components/custominput/CustomInput'
import {getUserById} from '../../../setup/redux/auth/actions'
import {AuthSlices} from '../../../setup/redux/auth/slices'
import {serialize} from 'object-to-formdata'
import {handleNotificationWithToastify} from '../../services/Functional'
import {getUserDisplayEmail} from '../../services/userEmailDisplay'

const initRequest = {
  password: '',
  confirm_password: '',
  old_password: '',
  email: '',
}
const {actions} = AuthSlices
const ProfileSchema = Yup.object().shape({
  old_password: Yup.string().required('Old password is required'),
  email: Yup.string().required('email is required'),
  password: Yup.string()
    //   .min(8, 'Minimum 8 characters')
    .max(50, 'Maximum 50 characters'),
  //   .required('Password is required'),
  confirm_password: Yup.string()
    .oneOf([Yup.ref('password'), undefined], 'Password does not match')
    .required('Confirm password is required'),
})

export const UpdatePassword = () => {
  const navigate = useNavigate()
  const dispatch: Dispatch<any> = useDispatch()
  const [loading, setLoading] = useState<boolean>(false)
  const [isTouched, setIsTouched] = useState<boolean>(false)
  const [isPasswordValid, setIsPasswordValid] = useState<boolean>(false)
  const [oldPasswordShow, setOldPasswordShow] = useState<boolean>(false)
  const [passwordShow, setPasswordShow] = useState<boolean>(false)
  const [confirmPasswordShow, setConfirmPasswordShow] = useState<boolean>(false)
  const [mfaLoading, setMfaLoading] = useState<boolean>(false)

  // @ts-ignore
  const {user} = useSelector<RootState>((state) => state.auth)

  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true)
      try {
        dispatch(getUserById(user.sub || user.id, 'show'))
      } catch (error) {
        console.error('Error fetching user data:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchUserData()
  }, [user])

  const saveRequest = (values: any) => {
    setLoading(true)
    postRequest(`${process.env.REACT_APP_API_BASE_URL}auth/change-password`, values).then(
      (response) => {
        setLoading(false)
        Swal.fire({
          title: response.data.success ? 'Password Changed!' : 'Warning',
          html: response.data.message,
          icon: response.data.success ? 'success' : 'warning',
          allowOutsideClick: false,
        })
          .then(() => {
            Swal.close()
            navigate('/dashboard')
          })
          .catch((e: any) => {
            setLoading(false)
          })
      }
    )
  }

  const handleMfaToggle = (checked: boolean) => {
    setMfaLoading(true)
    const updateData = {
      id: user.sub || user.id,
      name: user.name,
      username: user.username,
      email: getUserDisplayEmail(user),
      phone: user.phone,
      country_code: user.country_code,
      internal_notes: user.internal_notes,
      avatar: user.avatar,
      is_two_factor_auth: checked,
    }
    const formData: any = serialize(updateData)
    postRequest(
      `${process.env.REACT_APP_API_BASE_URL}auth/update-profile`,
      formData,
      {
        'Content-Type': 'multipart/form-data',
      }
    )
      .then((response) => {
        setMfaLoading(false)
        handleNotificationWithToastify(response.data)
        if (response.data.success) {
          dispatch(actions.updateUser(response.data.data))
        }
      })
      .catch((er) => {
        setMfaLoading(false)
      })
  }

  let userDetail = {
    password: '',
    confirm_password: '',
    old_password: '',
    email: getUserDisplayEmail(user),
  }

  return (
    <>
      {(loading || mfaLoading) && <Loader />}
      <PageTitle>Security Overview</PageTitle>
      <div id='kt_content_container' className='container'>
        <Formik
          enableReinitialize={true}
          initialValues={userDetail || initRequest}
          validationSchema={ProfileSchema}
          onSubmit={(values) => {
            saveRequest(values)
          }}
        >
          {({values, handleSubmit, handleChange, errors, touched, handleBlur}) => {
            return (
              <Form className='form' autoComplete='false'>
                <div className='card gutter-b'>
                  <div className='card-body'>
                    <div className='row'>
                      <div className='col-md-4'>
                        <div className='form-group'>
                          <label className='form-label' htmlFor='email'>
                            Email <span className='text-danger'>*</span>
                          </label>
                          <input
                            type='email'
                            className='form-control'
                            id='email'
                            name='email'
                            placeholder='Enter Email'
                            disabled={true}
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <ErrorMessage name='email' component='div' className='text-danger mt-2' />
                        </div>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-4'>
                        <div className='form-group'>
                          <label className='form-label'>
                            Current Password<span className='text-danger'>*</span>
                          </label>
                          <Field
                            name='old_password'
                            type={!oldPasswordShow ? 'password' : 'text'}
                            component={CustomInput}
                            placeholder='******'
                            className='form-control'
                            icon={
                              <img
                                className='cursor-pointer'
                                alt='show'
                                src={
                                  !oldPasswordShow
                                    ? toAbsoluteUrl('/media/Hide.svg')
                                    : toAbsoluteUrl('/media/Show.svg')
                                }
                                onClick={() => setOldPasswordShow(!oldPasswordShow)}
                              />
                            }
                          />
                          <ErrorMessage
                            name='old_password'
                            component='div'
                            className='text-danger mt-2'
                          />
                        </div>
                      </div>
                      <div className='col-md-4'>
                        <div className='form-group'>
                          <label className='form-label'>
                            New Password<span className='text-danger'>*</span>
                          </label>
                          <Field
                            name='password'
                            type={!passwordShow ? 'password' : 'text'}
                            component={CustomInput}
                            placeholder='******'
                            className='form-control'
                            onFocus={() => setIsTouched(true)}
                            onChange={(e: any) => {
                              handleChange(e)
                              const newPassword = e.target.value
                              setIsPasswordValid(checkPasswordValidity(newPassword))
                            }}
                            icon={
                              <img
                                className='cursor-pointer'
                                alt='show'
                                src={
                                  !passwordShow
                                    ? toAbsoluteUrl('/media/Hide.svg')
                                    : toAbsoluteUrl('/media/Show.svg')
                                }
                                onClick={() => setPasswordShow(!passwordShow)}
                              />
                            }
                          />
                          <ErrorMessage
                            name='password'
                            component='div'
                            className='text-danger mt-2'
                          />
                        </div>
                        {isTouched && (
                          <PasswordValidationUI password={values.password} isTouched={isTouched} />
                        )}
                      </div>
                      <div className='col-md-4'>
                        <div className='form-group'>
                          <label className='form-label'>
                            Confirm Password<span className='text-danger'>*</span>
                          </label>
                          <Field
                            name='confirm_password'
                            type={!confirmPasswordShow ? 'password' : 'text'}
                            component={CustomInput}
                            placeholder='******'
                            className='form-control'
                            icon={
                              <img
                                className='cursor-pointer'
                                alt='show'
                                src={
                                  !confirmPasswordShow
                                    ? toAbsoluteUrl('/media/Hide.svg')
                                    : toAbsoluteUrl('/media/Show.svg')
                                }
                                onClick={() => setConfirmPasswordShow(!confirmPasswordShow)}
                              />
                            }
                          />
                          <ErrorMessage
                            name='confirm_password'
                            component='div'
                            className='text-danger mt-2'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='card gutter-b'>
                  <div className='card-body'>
                    <div className='row'>
                      <div className='col-md-12'>
                        <div className='form-group m-0'>
                          <div className='d-flex align-items-center justify-content-between'>
                            <div className='d-flex align-items-center'>
                            <span className='me-3' style={{width: '40px', height: '40px', display: 'inline-block'}}>
                              <KTSVG
                                path='/media/icons/duotune/general/security-icon.svg'
                                className=''
                                svgClassName='w-40px h-40px'
                                svgIconClassnameApply={false}
                              />
                            </span>
                              <div className='d-flex flex-column gap-1'>
                                <div className='form-label font-weight-semibold text-midnight-blue-black m-0'>Enforce two-step verification</div>
                                <div className='text-muted small'>
                                  Add an extra layer of security with two-step verification.
                                </div>
                              </div>
                            </div>
                            <div className='form-check form-switch'>
                              <input
                                className='form-check-input'
                                type='checkbox'
                                id='is_two_factor_auth'
                                name='is_two_factor_auth'
                                checked={user.is_two_factor_auth || false}
                                disabled={mfaLoading}
                                onChange={(e) => {
                                  handleMfaToggle(e.target.checked)
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='card gutter-b'>
                  <div className='card-body'>
                    <div className='row'>
                      <div className='col-md-12'>
                        <button
                          type='submit'
                          onSubmit={() => handleSubmit}
                          className={`btn btn-primary ${!isPasswordValid ? 'disabled-btn' : ''}`}
                          disabled={!isPasswordValid}
                        >
                          Update
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            )
          }}
        </Formik>
      </div>
    </>
  )
}
